let entries : any[] = [];
const LIMIT = 2500;
const moduleLevels : any = {};
const LOG_LEVELS = ["debug", "log", "error"];

type LogLevel = "debug" | "log" | "error";

let logEnabled = true;

let addTimestamp = false;

export function getEntries()
{
	return [...entries];
}

export function clean() {
	entries = []
	log("Log has been cleaned");
}

export function enableLog(enabled : boolean)
{
	logEnabled = enabled;
}

export function debug(module : string, ...args : any[])
{
	_log(module, "debug", ...args);
}

export function log(module : string, ...args : any[])
{
	_log(module, "log", ...args);
}

export function logOnly(module : string, ...args : any[])
{
	_logOnly(module, "log", ...args);
}

export function error(module : string, ...args : any[])
{
	_log(module, "error", ...args);
}

export function errorOnly(module : string, ...args : any[])
{
	_logOnly(module, "error", ...args);
}

export function _log(module : string, level : LogLevel, ...args : any[])
{
	const time = Date.now();
	entries.push({module, level, args, time});
	if (entries.length > LIMIT) entries.shift();

	_logOnly(module, level, args);
}

export function _logOnly(module : string, level : LogLevel, ...args : any[])
{
	let moduleLevel = getModuleLevel(module);
	if (moduleLevel && LOG_LEVELS.indexOf(level) >= LOG_LEVELS.indexOf(moduleLevel)) {
		if (logEnabled) {
			if (addTimestamp) {
				console[level]((new Date().toISOString())+" [" + module + "]", ...args);
			}
			else {
				console[level]("[" + module + "]", ...args);
			}
		}
	}
}

export function getModuleLevel(module : string)
{
	if (module in moduleLevels) {
		return moduleLevels[module];
	} else {
		return debug;
	}
}

export function setModuleLevel(module : string, level : LogLevel)
{
	if (level) moduleLevels[module] = level;
	else moduleLevels[module] = null;
}


const logging = {log, debug, error, enableLog, getEntries, clean};
export default logging;
